

<app-header></app-header>
<!-- Main Header Account -->
<app-right-side></app-right-side>
<div class="container" [dir]="direction">
    <div class="row">
        <div class="col col-xl-9 order-xl-2 col-lg-9 order-lg-2 col-md-12 order-md-1 col-sm-12 col-12" style="top:0px">
            <div class="ui-block"  style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                <div class="ui-block-title">
                    <h6 class="title" style="color: var(--text-color);"><i class="fad fa-lock"></i>&nbsp;{{'change-password.title' | translate}}</h6>
                </div>
                <div class="ui-block-content">


                    <!-- Change Password Form -->

                    <form [formGroup]="changeForm" (ngSubmit)="changePassword()">
                        <div class="row">

                            <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div class="form-group">
                                    <label class="control-label" style="color: var(--text-color);">{{'change-password.current' | translate}} <span style="color: red;"> *
                                        </span></label>
                                    <input class="form-control" type="password" formControlName="currentPass" value="" [ngClass]="{ 'is-invalid': submitted && f.currentPass.errors }"  style="background-color: var(--background-color); color: var(--text-color);">
                                    <div *ngIf="submitted && f.currentPass.errors" class="invalid-feedback">
                                        <div *ngIf="f.currentPass.errors.required">{{'change-password.pass_req' | translate}}</div>
                                    </div>
                                    <small class="form-text text-muted error" *ngIf="!changeForm.controls['password'].valid && !isSubmitted">
                                        {{'change-password.hint' | translate}}
                                    </small>
                                </div>
                            </div>

                            <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                                <div class="form-group">
                                    <label class="control-label" style="color:var(--text-color); font-size: 1rem; text-align: center;">{{'change-password.your_pass' | translate}}
                                        <span style="color: red;"> * </span></label>
                                    <input class="form-control" name="password" placeholder="{{'change-password.enter_pass' | translate}}" formControlName="password" type="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" style="background-color: var(--background-color); color: var(--text-color);">
                                    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                        <div *ngIf="f.password.errors.required && submitted">{{'change-password.pass_req' | translate}}
                                        </div>
                                    </div>
                                    <small class="form-text text-muted error">
                                        {{'change-password.hint' | translate}}
                                    </small>

                                </div>
                            </div>
                            <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                                <div class="form-group">
                                    <label class="control-label" style="color:var(--text-color); font-size: 1rem; text-align: center;">{{'change-password.conf_pass' | translate}}
                                        <span style="color: red;"> * </span></label>
                                    <input class="form-control" name="password" placeholder="{{'change-password.conf_pass' | translate}}" formControlName="confirmPassword" type="password" [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }" style="background-color: var(--background-color); color: var(--text-color);">
                                    <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback">
                                        <div *ngIf="f.confirmPassword.errors.required">{{'change-password.pass_req' | translate}}  {{'change-password.hint' | translate}}</div>
                                        <div *ngIf="f.confirmPassword.errors.mustMatch">{{'change-password.pass_match' | translate}}</div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="errorMessage != ''" class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div *ngIf="errorMessage != ''" class="alert alert-danger" role="alert">
                                    {{errorMessage}}
                                </div>
                            </div>


                            <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <button [disabled]="loading" class="btn btn-primar1y btn-l1g full-w1idth" style="background-color: rgb(0, 0, 0); color: #fff; font-size: 15px;">
                                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                                    {{'change-password.change_pass' | translate}}
                                </button>
                            </div>

                        </div>
                    </form>

                    <!-- ... end Change Password Form -->
                </div>
            </div>
        </div>

        <div class="col col-xl-3 order-xl-1 col-lg-3 order-lg-1 col-md-12 order-md-2 col-sm-12 col-12 responsive-display-none" style="top:0px">
            <div class="ui-block" style="background-color: var(--backgroundpost-color); color: var(--text-color);">

                <!-- Your Profile  -->

                <div class="your-profile" >
                    <!-- <div class="ui-block-title ui-block-title-small">
                        <h6 class="title">Your PROFILE</h6>
                    </div> -->

                    <div id="accordion" role="tablist" aria-multiselectable="true" >
                        <div class="card" style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                            <div class="card-header" role="tab" id="headingOne">
                                <h6>
                                    <a data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne" dir="ltr">
                                        <i class="fad fa-user-cog"></i>&nbsp;Profile Settings
                                    </a>
                                </h6>
                            </div>

                            <div id="collapseOne" class="collapse show" role="tabpanel" aria-labelledby="headingOne">
                                <ul class="your-profile-menu">
                                    <li>
                                        <a routerLink="/profile-setting" style="color: var(--text-color);"><i class="fad fa-id-card"></i>&nbsp;Personal Information</a>
                                    </li>

                                    <li>
                                        <a routerLink="/change-password" style="color: var(--text-color);"><i class="fad fa-lock"></i>&nbsp;Change Password</a>
                                    </li>
                                    <li>
                                        <a routerLink="/hobbies-and-intrests" style="color: var(--text-color);"><i class="fad fa-icons"></i>&nbsp;Hobbies and Interests</a>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="ui-block-title">
                        <a routerLink="/friend-requests" class="h6 title" style="color: var(--text-color);"><i class="fad fa-user-clock"></i>&nbsp;Friend Requests</a>
                        <!-- <a routerLink="/friend-requests" class="items-round-little bg-blue">4</a> -->
                    </div>
                    <!-- <div class="ui-block-title ui-block-title-small">
						<h6 class="title">FAVOURITE PAGE</h6>
					</div>
					<div class="ui-block-title">
						<a href="javascript:void(0);" class="h6 title">Create Fav Page</a>
					</div>
					<div class="ui-block-title">
						<a href="javascript:void(0);" class="h6 title">Fav Page Settings</a>
					</div> -->
                </div>

                <!-- ... end Your Profile  -->

            </div>
        </div>
    </div>
</div>

<!-- ... end Your Account Personal Information -->